import { supabase } from "@/integrations/supabase/client";

export interface BroadcastParams {
  title: string;
  message: string;
  targetFilter?: {
    subscriptionTier?: string[];
    minCreatedDate?: string;
  };
}

export interface BroadcastResponse {
  success: boolean;
  message: string;
  recipients: number;
  failed?: number;
}

export interface BroadcastHistory {
  id: string;
  title: string;
  message: string;
  sent_by: string;
  sent_at: string;
  recipient_count: number;
  target_filter: any;
  status: string;
}

/**
 * Envía una notificación broadcast a múltiples usuarios
 */
export const sendBroadcastNotification = async (
  params: BroadcastParams
): Promise<BroadcastResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('broadcast-notification', {
      body: params
    });

    if (error) throw error;

    return data as BroadcastResponse;
  } catch (error) {
    console.error('Error sending broadcast notification:', error);
    throw error;
  }
};

/**
 * Obtiene el historial de broadcasts enviados
 */
export const getBroadcastHistory = async (): Promise<BroadcastHistory[]> => {
  try {
    const { data, error } = await supabase
      .from('broadcast_notifications')
      .select('*')
      .order('sent_at', { ascending: false })
      .limit(50);

    if (error) throw error;

    return data || [];
  } catch (error) {
    console.error('Error fetching broadcast history:', error);
    return [];
  }
};
